import { themeCssVariables } from 'app-ui/theme';

import { type ClerkAppearance } from '@/auth/clerk/types/ClerkAppearance';

// Every value is one of our CSS variables, so Clerk's screens use our colors,
// font and radius, and follow the light or dark theme class by themselves.
// Borders are left to Clerk, which derives them (and its badges' text) from
// colorNeutral: our light border color made its badges unreadable.
export const CLERK_APPEARANCE: ClerkAppearance = {
  variables: {
    colorPrimary: themeCssVariables.color.blue,
    colorPrimaryForeground: themeCssVariables.font.color.onAccent,
    colorDanger: themeCssVariables.color.red,
    colorSuccess: themeCssVariables.color.green,
    colorWarning: themeCssVariables.color.orange,
    colorNeutral: themeCssVariables.font.color.primary,
    colorForeground: themeCssVariables.font.color.primary,
    colorMutedForeground: themeCssVariables.font.color.tertiary,
    colorMuted: themeCssVariables.background.secondary,
    colorBackground: themeCssVariables.background.primary,
    colorInput: themeCssVariables.background.transparent.lighter,
    colorInputForeground: themeCssVariables.font.color.primary,
    colorRing: themeCssVariables.color.blue,
    colorShadow: themeCssVariables.boxShadow.color,
    colorModalBackdrop: themeCssVariables.background.overlaySecondary,
    fontFamily: themeCssVariables.font.family,
    fontFamilyButtons: themeCssVariables.font.family,
    fontSize: themeCssVariables.font.size.md,
    borderRadius: themeCssVariables.border.radius.md,
  },
  options: {
    // Our own product mark sits above the sign-in card.
    logoPlacement: 'none',
    socialButtonsVariant: 'blockButton',
  },
};
